// Analytics tracking utility functions

const isProduction = process.env.NEXT_PUBLIC_NODE_ENV === "production";

export function trackEvent(event, properties = {}) {
  if (
    isProduction &&
    typeof window !== "undefined" &&
    window.analytics &&
    typeof window.analytics.track === "function"
  ) {
    window.analytics.track(event, properties);
  }
}

export function pageView(name, properties = {}) {
  if (
    isProduction &&
    typeof window !== "undefined" &&
    window.analytics &&
    typeof window.analytics.page === "function"
  ) {
    window.analytics.page(name, properties);
  }
}

export function identifyUser(userId, traits = {}) {
  if (
    isProduction &&
    typeof window !== "undefined" &&
    window.analytics &&
    typeof window.analytics.identify === "function"
  ) {
    window.analytics.identify(userId, traits);
  }
}
